import { Pipe, PipeTransform } from '@angular/core';
import { map } from 'lodash';

@Pipe({
  name: 'valuesBy',
  standalone: true,
})
export class ValuesByPipe implements PipeTransform {
  transform<T extends Record<keyof T, unknown>>(
    entities: T[],
    key: keyof T
  ): any[] {
    return map(entities, key);
  }
}
